/**
 * expert-dialog コンポーネント専用i18n定数
 */

export const EXPERT_DIALOG_I18N = {
  // パンくずリスト
  breadcrumb: {
    userList: $localize`:@@home.expertDialog.breadcrumb.userList:ユーザー一覧`,
    contactBook: $localize`:@@home.expertDialog.breadcrumb.contactBook:連絡帳`,
  },

  // メッセージ
  message: {
    sendSuccess: $localize`:@@home.expertDialog.message.sendSuccess:送信しました`,
    sendFailed: $localize`:@@home.expertDialog.message.sendFailed:送信に失敗しました。時間を置いてお試しください。`,
  },
} as const;

export type ExpertDialogI18n = typeof EXPERT_DIALOG_I18N;
